import React from "react";
import { countries } from "../Constants/Constant";

const getCountryName = (countryCode) => {
    
    let country=countries.filter((country)=>country.code===countryCode);
    return country? country[0]?.label: countryCode;
}

export default getCountryName;